// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"d578730e","299":"a98e8f6b","672":"760cabb1"}[chunkId] + ".chunk.js";
};